import { NWayConfirmationModal, NWayConfirmationMode } from './n_way_confirmation_modal.service';

export class PromisedNWayConfirmationModal {
    _promise;

    constructor(message: string, modes: NWayConfirmationMode[], alternativeStyle = false) {
        this._promise = new Promise((resolve) => {
            const newModes: NWayConfirmationMode[] = [];
            for (const mode of modes) {
                newModes.push({
                    name: mode.name,
                    promiseValue: mode.promiseValue,
                    buttonText: mode.buttonText,
                    callback: () => {
                        resolve(mode.promiseValue);
                        if (typeof mode.callback === 'function') {
                            mode.callback();
                        }
                    },
                    isCancel: mode.isCancel,
                    isEscape: mode.isEscape,
                    displayButton: mode.displayButton,
                    styleObj: mode.styleObj,
                    classList: mode.classList,
                });
            }

            new NWayConfirmationModal(message, newModes, alternativeStyle);
        });
    }

    get promise(): Promise<string> {
        return this._promise;
    }
}
